var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container",style:({
      opacity: _vm.screensaverOpacity,
      transform: `scale(${_vm.screensaverOpacity * 0.1 + 0.9})`,
      backgroundImage:
        'url(/newsletter/hero/newsletter-hero_essen_2025-04-07_001.jpg)',
    })}),_c('div',{staticClass:"flyer-bg",style:({
      opacity: _vm.screensaverOpacity,
      background: 'black',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }